export default function isValidPassword (password) {
  // Does it contain at least 8 characters?
  if (password) {
    if (password.length < 8) {
      return 'Password must contain at least 8 characters'
    }
    // Does it contain a lower case letter?
    let regExpLowerCaseLetter = new RegExp('[a-z]+')
    if (!regExpLowerCaseLetter.test(password)) {
      return 'Password must contain at least a lower case letter'
    }
    // Does it contain an upper case letter?
    let regExpUpperCaseLetter = new RegExp('[A-Z]+')
    if (!regExpUpperCaseLetter.test(password)) {
      return 'Password must contain at least an upper case letter'
    }
    // Does it contain a number?
    let regExpNumber = new RegExp('[0-9]+')
    if (!regExpNumber.test(password)) {
      return 'Password must contain at least a number'
    }
    // Does it contain a special character?
    let regExpSpecialCharacter = new RegExp('[!@#$%^&*()_+\\-=\\[\\]{};\':"\\\\|,.<>\\/?]+')
    if (!regExpSpecialCharacter.test(password)) {
      return 'Password must contain at least a special character'
    }
    return true
  }
  return 'Password is not valid'
}
